import auth from '@/f1/service/auth';
import Language from './language';

const _i18n_data = {
  username: {
    EN : () => `Username required`,
    KO : () => `아이디를 입력하세요.`,
  },
  password: {
    EN : () => `Password required`,
    KO : () => `비밀번호를 입력하세요`,
  },
  lock: {
    EN : () => `Please wait server response.`,
    KO : () => `서버 응답을 기다리세요`,
  },
  trying: {
    EN : () => `Try to login`,
    KO : () => `로그인중입니다`,
  },
};

const App = {
  components: { Language },
  computed: { i18n_data() { return _i18n_data; } }, // i18n 메세지 변환용.
  data: () => ({ remember_username: false, m: { username: '', password: '' }, lock: false, }),
  methods: {
    // reset() { this.$router.push({ name: 'auth_reset'}); },
    // regist() { this.$router.push({ name: 'auth_register'}); },
    async login() {
      if(_.isEmpty(this.m.username)) { 
        return this.$toastr.e(this.i18n_msg('username') || 'Username required.'); }
      if(_.isEmpty(this.m.password)) { return this.$toastr.e(this.i18n_msg('password') || 'password required.'); }
      if(this.lock) { return this.$toastr.i(this.i18n_msg('lock') || 'Please wait, I\'m trying to login.'); }
      this.lock = true;
      try {
        this.$toastr.i(this.i18n_msg('trying') || 'Try to login.');
        await auth.login(this.m.username, this.m.password);
        // 아이디 저장여부
        if(this.remember_username) { window.localStorage.setItem('username', this.m.username); } else { window.localStorage.removeItem('username'); }
        this.$router.replace(this.$route.query.redirect || '/'); // 대시보드 경로로 변경 필요함
      } catch(e) { this.$toastr.e(e.data && (e.data.message || e.data) || 'unexpected error.'); console.log(e); }
      this.lock = false;
    }
  },
  created() { console.log('[vue] login', 'created'); },
  destroyed() { console.log('[vue] login', 'destroyed'); },
  mounted() {
    if(auth.isAuthenticated()) { this.$router.replace('/');  } // 대시보드 경로로 변경 필요함
    if(window.localStorage.getItem('username')) { this.checked = true; this.m.username = window.localStorage.getItem('username'); }
  }
}

const _loader = (obj) => {
  // Critical Error
  if(typeof yourVariable !== 'object' || yourVariable === null) {
  }
  console.log(obj)
  Object.assign(_var, obj);
  // 지원 언어와 comps 확인
  return App;
}

export default App